import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
        error: null,
        videos: null,
        //devices: [{ id: 0, name: "Local" }],
        //searchDevices: { /*0:{ id: 0, name: "Local" }*/ },
        loading: false,
        currentVideo: null
};

const vimeoLoadSuccess = (state, action) => {
    console.log(action);
    
    return updateObject( state, { loading: false, videos: action.videos.vimeoclip.elements } );
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.VIMEO_LOAD_START:
            return updateObject(state, { loading: true });
        case actionTypes.VIMEO_LOAD_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.VIMEO_LOAD_SUCCESS:
            return vimeoLoadSuccess(state, action);
        case actionTypes.VIMEO_SET_CURRENT_VIDEO:
            return updateObject(state, { currentVideo: action.video });
        /*case actionTypes.DEVICE_SET_SEARCH:
            return updateObject(state, { searchDevices: action.devices });*/
        default: 
            return state;
    }
}

export default reducer;
